import React from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import { Link } from 'gatsby-theme-material-ui';

import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

export const ProfileMenu = ({ userProfile }) => {
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const { firstName, lastName, profilePicture, signOut, userMenu } = userProfile;

  return (
    <Box sx={{ flexGrow: 0, zIndex: 10000 }}>
      <Tooltip title="Open Menu">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar
            sx={{ backgroundColor: 'secondary.main' }}
            alt={`${firstName} ${lastName}`}
            src={profilePicture}
          />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}>
        {userMenu?.map(({ id, url, linkText, linkTitle }) => (
          <MenuItem key={id} onClick={handleCloseUserMenu}>
            <Link to={url} title={linkTitle}>
              <Typography textAlign="center">{linkText}</Typography>
            </Link>
          </MenuItem>
        ))}
        <MenuItem
          key={'sout'}
          onClick={() => {
            handleCloseUserMenu();
            signOut();
          }}>
          <Typography textAlign="center">Sign Out</Typography>
        </MenuItem>{' '}
      </Menu>
    </Box>
  );
};

ProfileMenu.propTypes={
  userProfile:PropTypes.shape({
    firstName:PropTypes.string.isRequired,
    lastName:PropTypes.string.isRequired,
    profilePicture:PropTypes.string.isRequired,
    signOut:PropTypes.func.isRequired,
    userMenu:PropTypes.arrayOf(PropTypes.shape({
      id:PropTypes.string.isRequired,
      url:PropTypes.string.isRequired,
      linkText:PropTypes.string.isRequired,
      linkTitle:PropTypes.string.isRequired,

    }))
  })


};